import {
  AfterViewInit,
  Component,
  ContentChildren,
  Directive,
  ElementRef, HostListener,
  QueryList,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {SwiperOptions} from 'swiper';
import {Swiper} from 'swiper/types';


@Directive({
  selector: '[libCubeFace]',
  standalone: false,
})
export class CubeFaceDirective {
  constructor(public template: TemplateRef<unknown>) {
  }
}


@Component({
  selector: 'lib-cube',
  templateUrl: './cube.component.html',
  styleUrls: ['./cube.component.scss'],
  standalone: false,
})
export class CubeComponent implements AfterViewInit {
  @ContentChildren(CubeFaceDirective) faces!: QueryList<CubeFaceDirective>;
  @ViewChild('swiper') swiperRef: ElementRef | undefined;
  swiper?: Swiper;

  config: SwiperOptions = {
    effect: 'flip',
    cubeEffect: {
      shadow: false,
      slideShadows: true,
    },
    flipEffect: {
      limitRotation: true,
      slideShadows: true,
    },
    grabCursor: true,
    pagination: false,
    navigation: false,
    enabled: false,
    on: {
      beforeTransitionStart: () => window.getSelection()?.removeAllRanges(),
    }
  };

  ngAfterViewInit(): void {
    this.initializeSwiper();
  }

  private initializeSwiper(): void {
    if (!this.swiperRef) {
      console.error('NO SWIPER REF');
      return;
    }
    const nativeElement = this.swiperRef.nativeElement;

    if (this.faces.length > 1) {
      this.config.enabled = true;
      if (this.faces.length > 2) {
        this.config.effect = 'cube';
      }
      Object.assign(nativeElement, this.config);
    }
    nativeElement.initialize();
    this.swiper = nativeElement.swiper as Swiper;
  }

  flipCard(event: Event): void {
    if (this.faces.length !== 2 || !this.swiper) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    if (this.swiper.activeIndex === 0) {
      this.swiper.slideNext();
    } else if (this.swiper.activeIndex === 1) {
      this.swiper.slidePrev();
    }
  }


  private swipeBackTimeout: ReturnType<typeof setTimeout> | undefined;

  @HostListener('mouseleave')
  private onLeave(): void {
    if (this.faces.length < 2 || !this.swiper || this.swiper.destroyed) {
      return;
    }
    this.clearTimeout();
    const swiper = this.swiper;
    this.swipeBackTimeout = setTimeout(() => {
      if (!swiper || swiper.destroyed) {
        return;
      }
      swiper.slideTo(0);
    }, 300);
  }

  @HostListener('mouseenter')
  private onEnter(): void {
    if (this.swiper && this.swiper.destroyed) {
      this.initializeSwiper();
    }
    this.clearTimeout();
  }

  private clearTimeout(): void {
    if (this.swipeBackTimeout !== undefined) {
      clearTimeout(this.swipeBackTimeout);
    }
  }
}
